import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

import { Store } from '@ngrx/store';
import { take } from 'rxjs/operators';

import { AppState, getMyAuth } from '../store/app.state';

/**Guard che verifica che un utente sia autenticato prima di permettere la navigazione, altrimenti rimanda alla pagina di autenticazione */
@Injectable({providedIn: 'root'})
export class AuthGuard implements CanActivate {
    /**
     * Costruttore del servizio di controllo AuthGuard
     * @param router {Router} per la navigazione
     * @param store {Store<AppState>} stato a livello dell'applicazione
     */
    constructor(
        private router: Router,
        private store: Store<AppState>
    ) {}
    
    /**
     * Metodo dell'interfaccia CanActivate che implementa il controllo per permettere o meno l'accesso ad un path (e ai componenti collegati), verifica che l'autenticazione sia andata a buon fine
     * @param route {ActivatedRouterSnapshot}
     * @param router {RouterStateSnapshot}
     * @returns {boolean}
     */
    canActivate(
        route: ActivatedRouteSnapshot,
        router: RouterStateSnapshot
    ) {
        let isAuth: boolean;
        this.store.select(getMyAuth).pipe(
            take(1)
        ).subscribe( data => {
            isAuth = data.isAuth;
        })
        if(isAuth) {
            return true;
        }
        return this.router.navigate(['/auth'], {skipLocationChange: true});
    }
}